import APIClient from '@/shared/http/clients/api'

const resourceName = 'filial'
const APICore = process.env.APIBaseURLCore

const GetAll = (companyID, data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/empresa/${companyID}`, data, config)
const GetAllPaging = (companyID, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/empresa/${companyID}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const BranchRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete
}

export default BranchRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/branch.js